<soft-page>
  <soft-page-header [customClass]="'!p-0'">
    <div class="w-full mb-4">
      <soft-default-header
        [title]="steps[1].header | translate"
        [subtitle]="steps[1].subHeader | translate"
      />
      <soft-ds-progress-steps class="mx-2" [steps]="steps" [currentIndex]="1" />
    </div>
  </soft-page-header>

  <div class="soft-overline mt-4">
    {{'#LAGERKORREKTUR.PAGES.ARTIKEL_AUSWAHL.ARTIKEL' | translate}}
  </div>
  <soft-artikel-menge-auswahl
    [lagerplatzInhalt]="$safeNavigationMigration((lagerplatz$ | async)?.inhalt)"
    (artikelMengeChange)="onSelect($event)"
  />
</soft-page>
